<template>
  <layout>
    <template #search>
      <div class="search-box">
        <Input class="search-input-warp" v-model="name" placeholder="请输入域名，每行一个域名；支持字符为英文、数字、中文、“-”；“-”不能出现在域名首尾，且不能连续出现；如输入后缀将被自动忽略；" clearable style="width: 1010px;" />
        <Button class="search-btn-warp" type="primary" icon="ios-search" @click="search">查 询</Button>
      </div>
    </template>
    <div class="section">
      <div class="content">
        <div class="search-input-warp">
          <div style="display: flex; flex-wrap: wrap; padding: 10px 0;align-items: center;">
            <div>常用后缀：</div>
            <CheckboxGroup class="checkbox-type" v-model="sufSelectList">
              <Checkbox
                border
                v-for="item in sufList"
                :value="item.domainSufName"
                :key="item.domainSufName"
                :label="item.domainSufName"
                >{{ item.domainSufName }}</Checkbox
              >
            </CheckboxGroup>
          </div>
        </div>
        <div class="flex-content-end">
          <div class="h-title">查询结果</div>
        </div>
        <template v-if="isShow">
          <div class="showSensitive">限制注册！</div>
        </template>
        <div v-else style="margin-top: 30px; min-height: 250px">
          <Table
            class="search-table"
            ref="selection"
            :loading="loading"
            :show-header="false"
            :columns="columns"
            :data="list"
            @on-row-click="tableSelect"
            @on-select="select"
            @on-select-cancel="selectCancel"
          >
            <template slot="registerStatus" slot-scope="{ row }">
              {{ row.status | registerStatus }}
            </template>
            <template slot="price" slot-scope="{ row }">
              <span style="color: #3992e9">{{ row.price || "" }}元/首年</span>
            </template>
            <template slot="action" slot-scope="{ row, index }">
              <div style="display: flex; justify-content: flex-end">
                <Button
                  class="btns"
                  v-if="row.status === 0"
                  @click.stop="singleAddCart(row, index)"
                  >加入购物车</Button
                >
              </div>
            </template>
          </Table>
          <div style="margin-top: 20px">
            <Button class="r-btn" type="primary" ghost @click="allSelect">{{
              allCheck ? "取消全选" : "全选"
            }}</Button>
            <Button
              class="r-btn"
              style="margin-left: 20px"
              @click="batchBuy"
              :disabled="!_disabled"
              :loading="t_allDisabled"
              >批量加入购物车</Button
            >
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>
<script>
import layout from "./components/layout.vue";
import { searchDomain, addShopCart } from "api/domain.js";
import { mapActions, mapState } from "vuex";
export default {
  name: "price",
  components: {
    layout,
  },
  filters: {
    registerStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未注册";
          break;
        case 1:
          title = "已注册";
          break;
        case 2:
          title = "查询失败";
          break;
      }
      return title;
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(val) {
        this.allCheck = val.every((o) => o._checked);
      },
    },
    "domainQueryData.domainSuffix": {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          val.forEach((item) => {
            if (item.isCheck === 1) {
              this.sufSelectList.push(item.domainSufName);
            }
          });
          this.sufList = val;
          this.name = this.$route.query.name;
          this.search();
        }
      },
    },
  },
  computed: {
    ...mapState(["token", "domainQueryData"]),
    _disabled() {
      const checkedArr = this.list.filter((o) => o._checked);
      return checkedArr && checkedArr.length > 0;
    },
  },
  data() {
    return {
      name: "",
      columns: [
        {
          type: "selection",
          width: 60,
        },
        {
          key: "ym",
        },
        {
          slot: "registerStatus",
        },
        {
          slot: "price",
        },
        {
          slot: "action",
        },
      ],
      list: [],
      allCheck: false,
      sufList: [],
      loading: false,
      sufSelectList: [],
      count: 1,
      t_disabled: false,
      t_allDisabled: false,
      isShow:false,
      sensitiveWords:'',//敏感词
    };
  },
  async created() {
    this.name = this.$route.query.name;
    if (this.domainQueryData.domainSuffix.length === 0 || this.domainQueryData.sensitiveWords.length === 0) {
      this.ACT_DOMAIN_QUERY();
    }
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    batchBuy() {
      this.goodsNames = [];
      // 判断登录
      if (!this.token) {
        this.$router.push({ name: "login" });
        return;
      }
      const allData = this.list.filter((o) => o._checked);
      if (allData.length === 0) {
        this.$Message.warning("请选择要购买的域名！");
        return false;
      }
      this.goodsNames = allData.map((o) => {
        return o.ym;
      });
      this.t_allDisabled = true;
      this.req_addShopCart(this.goodsNames);
    },
    // // 搜索
    async req_search(suf) {
      if (!this.name) {
        this.$Message.warning("请输入要搜索的域名！");
        return false;
      }

      if(this.name !== this.$route.query.name){
        this.$router.replace('/search?name='+ this.name);
      }

      const list = {
        list: [`${this.name.split(".")[0]}${suf}`],
        suffix: suf,
      };
      this.loading = true;
      this.count += 1;
      const { code, data } = await searchDomain(list);
      if (this.count >= this.sufSelectList.length) {
        this.count = 1;
        this.list = [];
      }
      this.loading = false;
      if (code === 200) {
        if (data != null) {
          let filter = data.filter(item => {
            return item.status == 3
          })
          if (filter != null && filter.length > 0) {
            this.isShow = true
          }
        }
        const temp = data.map((o) => {
          return { ...o, _disabled: o.status === 1 };
        });
        this.list = [...this.list, ...temp];
      }
    },
    // 加入购物车
    async req_addShopCart() {
      try {
        const { code, data } = await addShopCart({
          domains: this.goodsNames,
          type: 0,
        });
        this.t_disabled && (this.t_disabled = false);
        this.t_allDisabled && (this.t_allDisabled = false);
        if (code === 200) {
          if (data.length === 0) {
            this.$Message.success("添加成功！");
            this.$router.push('/cart')
          } else {
            this.result = data;
          }
        }
      } catch (error) {
        this.t_disabled && (this.t_disabled = false);
        this.t_allDisabled && (this.t_allDisabled = false);
        console.log(error);
      }
    },
    // 搜索事件
    search() {
      this.name = this.name.replace(/\s*/g,'')
      if (!this.name) {
        this.$Message.warning("请输入要搜索的域名！");
        return false;
      }

      if (this.sufSelectList.length === 0) {
        this.$Message.warning("请选择要查询的后缀！");
        return false;
      }

      this.isShow = false

      this.domainQueryData.sensitiveWords.map(item => {
         if(this.name.toLowerCase().indexOf(item.toLowerCase()) !== -1){
          this.isShow = true
          return false
        }
      })

      if(!this.isShow){
        this.sufSelectList.forEach((o) => {
          this.req_search(o);
        });
      }
    },
    // 行选中
    tableSelect(row, index) {
      if (!row._disabled) {
        let temp = { ...this.list[index] };
        temp._checked = !temp._checked;
        this.$set(this.list, index, temp);
      }
    },
    // 全选
    allSelect() {
      const isAll = !this.allCheck;
      this.list.forEach((o, index) => {
        !o._disabled && (o._checked = isAll);
        this.$set(this.list, index, o);
      });
    },
    // 选中
    select() {
      let row = arguments[1];
      if (!row._disabled) {
        let index = this.list.findIndex((o) => o.ym === row.ym);
        row._checked = true;
        this.$set(this.list, index, row);
      }
    },
    // 取消选中
    selectCancel() {
      let row = arguments[1];
      let index = this.list.findIndex((o) => o.ym === row.ym);
      row._checked = false;
      this.$set(this.list, index, row);
    },
    //单个添加购物车
    async singleAddCart(item) {
      this.goodsNames = [];
      this.t_disabled = true;
      if (!this.token) {
        this.$router.push({ name: "login" });
        return;
      }
      this.goodsNames = [item.ym];
      this.req_addShopCart(this.goodsNames);
    },
  },
};
</script>
<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 28px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .showSensitive{
      width:100%;
      text-align: center;
      font-size: 20px;
      padding: 50px 0;
      color: #f85936;
    }
    .h-title {
      color: #333333;
      font-weight: bold;
      font-size: 24px;
    }
    .d-title {
      margin-left: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }
    .search-input-warp ::v-deep {
      width: 100%;
      margin: 40px 0 30px;
    }
    ::v-deep .search-table {
      .ivu-spin-dot{
        background-color: #ff5c35;
      }
      .ivu-table-body {
        .ivu-table-tbody {
          .ivu-table-row-hover td {
            background-color: #f4f7fe;
            .btns {
              background-color: #ff5c35 !important;
              border-color: #ff5c35 !important;
              color: #fff;
            }
          }
          .ivu-table-row {
            td:nth-child(1) {
              text-align: center;
              .ivu-checkbox-inner {
                border-radius: 50%;
              }
              .ivu-checkbox-focus {
                box-shadow: none;
              }
              .ivu-checkbox-checked .ivu-checkbox-inner {
                background-color: #fff;
                border-color: #ff5c35;
                &:after {
                  border-color: #ff5c35;
                }
              }
            }
          }
        }
      }
    }
    ::v-deep .search-input {
      .ivu-input {
        height: 80px !important;
        padding: 0 0px 0 50px !important;
        font-size: 24px;
        line-height: 80px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &:focus {
          box-shadow: none;
        }
      }
      .ivu-input-icon-clear {
        line-height: 80px;
        font-size: 24px;
      }
      .ivu-input-group-append {
        width: 170px;
      }
    }
    ::v-deep .search-select {
      height: 80px !important;
      .ivu-select-placeholder {
        height: 80px !important;
        line-height: 80px !important;
      }
      .ivu-select-selection {
        height: 80px !important;
        border-radius: 0;
      }
    }
    ::v-deep .search-btn {
      height: 80px;
      padding: 0 45px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .checkbox-type ::v-deep {
    .ivu-checkbox-wrapper-checked.ivu-checkbox-border{
      border-color: #F85936;
    }
    ::v-deep .ivu-checkbox-inner {
      margin-right: 3px;
    }
    ::v-deep .ivu-checkbox-focus{
      box-shadow: none;
    }
    ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #F85936;
      background-color: #F85936;
      margin-right: 3px;
    }
  }
  ::v-deep .r-btn{
    border-color: #F85936;
    color: #F85936;
    &:focus{
      box-shadow: none;
    }
  }
}
</style>
